import cx from 'classnames';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React from 'react';
import styles from '../layout.module.scss';
export var ContentWidth;
(function (ContentWidth) {
    ContentWidth["FLUID"] = "fluidWidth";
    ContentWidth["FIXED"] = "fixedWidth";
})(ContentWidth || (ContentWidth = {}));
export const Content = ({ children, contentWidth = ContentWidth.FLUID, noPadding = false, disableOverlayScroll = false, }) => {
    const innerContainerClass = cx(styles.innerContainer, {
        [styles.fixedWidth]: contentWidth === ContentWidth.FIXED,
        [styles.noPadding]: noPadding,
    });
    const pageContent = (React.createElement("main", { className: styles.page },
        React.createElement("div", { className: innerContainerClass }, children)));
    return disableOverlayScroll ? (React.createElement("div", { className: styles.contentNonOverlayScroll }, pageContent)) : (React.createElement(OverlayScrollbarsComponent, { options: {
            scrollbars: { autoHide: 'move' },
        }, className: cx('os-host-flexbox', styles.contentOverlayScroll) }, pageContent));
};
//# sourceMappingURL=content.js.map